var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_16",
    "data-name": "Layer 16",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4d4d4d;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.68,15.97h-12.21l-.39-12.52c-.03-.85-.72-1.52-1.57-1.52s-1.54.67-1.57,1.52l-.46,12.53h-1.08c-.78,0-1.42.63-1.42,1.42v3.17c0,.78.63,1.42,1.42,1.42h17.28c.78,0,1.42-.63,1.42-1.42v-3.17c0-.78-.63-1.42-1.42-1.42ZM5.94,3.48c.01-.31.26-.55.57-.55s.56.24.57.56l.39,12.49h-1.99l.45-12.49ZM21.1,20.55c0,.23-.19.42-.42.42H3.4c-.23,0-.42-.19-.42-.42v-3.17c0-.23.19-.42.42-.42h17.28c.23,0,.42.19.42.42v3.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.48,18.5h-2c-.28,0-.5.22-.5.5s.22.5.5.5h2c.28,0,.5-.22.5-.5s-.22-.5-.5-.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.02,18.5h-2c-.28,0-.5.22-.5.5s.22.5.5.5h2c.28,0,.5-.22.5-.5s-.22-.5-.5-.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.52,18.5h-2c-.28,0-.5.22-.5.5s.22.5.5.5h2c.28,0,.5-.22.5-.5s-.22-.5-.5-.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.7,18.5h-.45c-.28,0-.5.22-.5.5s.22.5.5.5h.45c.28,0,.5-.22.5-.5s-.22-.5-.5-.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.51,18.5h-.45c-.28,0-.5.22-.5.5s.22.5.5.5h.45c.28,0,.5-.22.5-.5s-.22-.5-.5-.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.25,13.58c2.48,0,4.5-2.02,4.5-4.5s-2.02-4.5-4.5-4.5-4.5,2.02-4.5,4.5,2.02,4.5,4.5,4.5ZM17.25,5.58c1.93,0,3.5,1.57,3.5,3.5s-1.57,3.5-3.5,3.5-3.5-1.57-3.5-3.5,1.57-3.5,3.5-3.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.28,11.3c.09.09.22.15.35.15.02,0,.03,0,.05,0,.15-.01.28-.09.37-.22l2.17-3.22c.15-.23.09-.54-.13-.69-.23-.15-.54-.09-.69.13l-1.83,2.72-.81-.81c-.2-.2-.51-.2-.71,0s-.2.51,0,.71l1.23,1.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModem);
export default __webpack_public_path__ + "static/media/modem.d3cdf473dcf303f386fb87f0ec70bdb4.svg";
export { ForwardRef as ReactComponent };